<template>
  <v-container>
    <div class="d-flex pb-10 mb-5">
      <v-btn text plain color="primary" link :to="{ name: 'All Providers' }">
        Provider Rates
      </v-btn>
      <v-icon color="primary"> mdi-menu-right </v-icon>
      <v-btn text plain color="primary">
        {{ $route.name }}
      </v-btn>
    </div>
    <v-toolbar flat color="white">
      <v-toolbar-title>Provider Corporations</v-toolbar-title>
      <v-divider class="mx-4" inset vertical></v-divider>
      <v-spacer></v-spacer>
      <v-btn
        :disabled="noEdit"
        color="primary"
        :dark="!noEdit"
        class="btn mb-2"
        @click="createCorporation"
      >
        New Corporation
      </v-btn>
    </v-toolbar>
    <v-toolbar flat color="white">
      <v-row class="mt-5 mb-2">
        <v-spacer></v-spacer>
        <v-col cols="12" md="3">
          <v-select
            height="42"
            v-model="filterType"
            :items="corporationTypes"
            label="Show corporation type"
          ></v-select>
        </v-col>
        <v-col cols="12" md="3">
          <v-text-field
            v-model="searchQuery"
            clearable
            label="Search"
            height="42"
            dense
          ></v-text-field>
        </v-col>
      </v-row>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="tableData"
      class="elevation-4 mx-auto"
      :search="searchQuery"
    >
      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on">
              <v-icon
                x-small
                class="mr-2"
                color="primary"
                @click="editItem(item.providerCorporationId)"
                :disabled="noEdit"
              >
                fa fa-pencil-square-o
              </v-icon>
            </span>
          </template>
          <span>Edit item</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on">
              <v-icon
                x-small
                color="primary"
                class="mr-2"
                @click="deleteItem(item.providerCorporationId)"
                :disabled="item.providers.length > 0 ? true : false || noEdit"
              >
                fa fa-trash-o
              </v-icon>
            </span>
          </template>
          <span>Delete item</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on">
              <v-icon
                x-small
                color="primary"
                @click="
                  viewProviders(item.providers, item.providerCorporationId)
                "
              >
                fa fa-users
              </v-icon>
            </span>
          </template>
          <span>View associated providers</span>
        </v-tooltip>
      </template>
    </v-data-table>
    <v-dialog v-model="corporationDialog" persistent width="500">
      <individual-coporation-modal
        v-if="corporationDialog"
        :corporation="selectedItem"
        @close="corporationDialog = false"
      />
    </v-dialog>
    <v-dialog v-model="providersDialog" persistent width="900">
      <associated-providers-modal
        v-if="providersDialog"
        :providers="associatedProviders"
        :corporationId="providerCorporationId"
        :noEdit="noEdit"
        @close="providersDialog = false"
      />
    </v-dialog>
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
import IndividualCoporationModal from "../../components/modal/Individual-coporation-modal.vue";
import ProviderCorporation from "../../objs/ProviderCorporation";
import AssociatedProvidersModal from "../../components/modal/associated-providers-modal.vue";
import { formatPhone, formatTaxId } from "../../utils/format-utils";

export default {
  components: {
    IndividualCoporationModal,
    AssociatedProvidersModal,
  },
  data: () => ({
    providerCorporationId: "",
    corporationDialog: false,
    providersDialog: false,
    associatedProviders: [],
    selectedItem: new ProviderCorporation(),
    filterType: "All",
    searchQuery: "",
    headers: [
      {
        text: "Name",
        value: "name",
      },
      {
        text: "Tax ID",
        value: "taxId",
        sortable: false,
      },
      {
        text: "Corporation Type",
        value: "corporationType",
        sortable: false,
      },
      {
        text: "Address",
        value: "address",
        sortable: false,
      },
      {
        text: "Phone Number",
        value: "phoneNumber",
        sortable: false,
      },
      {
        text: "Actions",
        value: "actions",
        sortable: false,
      },
    ],
    corporationTypes: [
      "All",
      "Staffing agencies",
      "1099 Professional Corporations",
    ],
  }),
  computed: {
    ...mapGetters({
      corporations: "providerModule/corporations",
      programs: "optionModule/programs",
      rateUnitTypes: "optionModule/rateUnitTypes",
      services: "optionModule/services",
      sessionLocations: "optionModule/sessionLocations",
      taxStatuses: "optionModule/taxStatuses",
      noEdit: "securityModule/isReadOnly",
    }),
    tableData() {
      var corps = this.corporations.map((item) => ({
        ...item,
        // map additional fields for table display
        corporationType: item.isStaffingAgency
          ? "Staffing Agency"
          : "Provider Corporation",
        address: `${item.streetAddress} ${item.streetAddressLine2} ${item.city} ${item.state} ${item.zipCode}`,
        phoneNumber: formatPhone(item.phoneNumber),
        taxId: formatTaxId(item.taxId),
      }));

      // filters
      if (this.filterType === "Staffing agencies")
        corps = corps.filter(
          (item) => item.isStaffingAgency === true
        );
      else if (this.filterType === "1099 Professional Corporations")
        corps = corps.filter(
          (item) => item.isStaffingAgency === false
        );

      return corps;
    },
  },
  async created() {
    this.$store.dispatch("uxModule/showLoader", "Loading data...");
    await this.$store.dispatch("providerModule/getAllProviderCorporations");
    this.$store.dispatch("uxModule/hideLoader");
  },

  methods: {
    createCorporation() {
      this.selectedItem = new ProviderCorporation();
      this.corporationDialog = true;
    },
    editItem(corporationId) {
      const findIndex = this.corporations.findIndex(
        ({ providerCorporationId }) => providerCorporationId === corporationId
      );
      this.selectedItem = {
        ...this.corporations[findIndex],
      };
      this.corporationDialog = true;
    },
    async deleteItem(corporationId) {
      this.$store.dispatch(
        "uxModule/showLoader",
        "Deleting provider corporation"
      );
      const result = await this.$store.dispatch(
        "providerModule/deleteProviderCorporation",
        corporationId
      );
      this.$store.dispatch("uxModule/hideLoader");
      if (result)
        this.$store.dispatch(
          "uxModule/showSnackBarMsg",
          "Deleted successfully!"
        );
      else this.$store.dispatch("uxModule/showSnackBarMsg", "Raised an error!");
    },
    viewProviders(providers, id) {
      this.providerCorporationId = id;
      this.associatedProviders = providers;
      this.providersDialog = true;
    },
  },
};
</script>
